import axios from "axios";
// List products with Api
export const CourseEnding = async (jwt,user_id,type_id) => {

  let url = process.env.REACT_APP_ADMIN_API_URL + `/courseEnding`
  let data = "";
  let qs = require('qs');
  data = qs.stringify({
    'user_id': user_id,
    'type_id': type_id,
    "type": "course_level"
  });
  try {
    const response = await axios.post(
        url,
        data,
      {
        headers: {
            'Authorization': 'Bearer '+jwt, 
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    return response.data

  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};